import axios, { AxiosError } from 'axios';
import { DefaultGetAllResponse, DefaultGetResponse } from './rest';
import { UserSimple } from '~/types/models';
import { useQuery, UseQueryOptions } from 'react-query';

export const queryKeys = {
  all: ['users'] as const,
  lists: () => [...queryKeys.all, 'lists'] as const,
  details: () => [...queryKeys.all, 'details'] as const,
  detail: (id: string) => [...queryKeys.details(), id] as const,
};

export type GetUsersResponse = DefaultGetAllResponse<UserSimple>;

export async function getUsers() {
  const res = await axios.get<GetUsersResponse>('/api/v2/users');

  return res.data;
}

export function useUsers(
  options?: UseQueryOptions<GetUsersResponse, AxiosError>
) {
  return useQuery<GetUsersResponse, AxiosError>(
    queryKeys.lists(),
    getUsers,
    options
  );
}

export type GetUserResponse = DefaultGetResponse<UserSimple>;

export async function getUser(id: string) {
  const res = await axios.get<GetUserResponse>(`/api/v2/users/${id}`);

  return res.data;
}

export function useUser(
  id: string,
  options?: UseQueryOptions<GetUserResponse, AxiosError>
) {
  return useQuery<GetUserResponse, AxiosError>(
    queryKeys.detail(id),
    () => getUser(id),
    options
  );
}

export function useCurrentUser(
  options?: UseQueryOptions<GetUserResponse, AxiosError>
) {
  return useUser('me', options);
}
